import { Component, Input } from '@angular/core';

@Component({
  selector: 'evrideo-mark-out-icon',
  templateUrl: './mark-out-icon.component.html',
  styleUrls: ['./mark-out-icon.component.scss'],
})
export class MarkOutIconComponent {
  @Input()
  overrideStyle: Record<string, string> = {};
}
